import { selectorAuth, ActionAuthLoginSuccess } from './../../../auth.reducer';
import { Component } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { OperationTypes } from '@app/core/auth/auth.interfaces';
import { Subject } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { AppConfig } from '@app/config/app.config';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { LoginIdResponse } from '@app/shared/mock/response-types.examples';
import { InfoService } from '@app/core/info/info.service';
import { LocalStorageService, SessionStorageService } from '@app/core/local-storage/local-storage.service';
import { selectorSettings } from '@app/profile/settings/settings.reducer';
import { ActionAuthLogin } from '@app/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { environment } from '@env/environment';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core/animations/router.transition';
import { Router, ActivatedRoute } from '@angular/router';
import { BusinessService } from '@app/business/business.service';
import { BissService } from '@app/shared/services/biss.service';
import { MatDialog } from '@angular/material/dialog';
import { configureReCaptchaWithEnv } from '@app/core/auth/reCaptcha-util';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cqes-login',
    templateUrl: './cqes-login.component.html',
    styleUrls: ['./cqes-login.component.scss']
})
export class CqesLoginComponent implements OnInit, OnDestroy {

    readonly operationTypes: typeof OperationTypes = OperationTypes;
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

    isAuthenticated: boolean;
    timer: NodeJS.Timer;
    timeLeft: number;
    loading: boolean;
    personalId: string;
    personalIdField: string;
    qrData: string;
    uniqueToken: string;
    recaptchaResponse: string;
    captchaEnabled: boolean;
    fingerprint: any;

    loginForm = new FormGroup({
        personalId: new FormControl(''),
        recaptcha: new FormControl('')
    });
    usingLang: string;
    reCaptcha2SiteKey: string;
    invisibleCaptchaSiteKey: string;
    operationType: OperationTypes;
    unsubscribe$: Subject<void> = new Subject<void>();
    progressBarService: any;
    isIE11 = false;
    type: any;
    setStyle: boolean = false;

    _token: string;
    accounts: any;
    errorMessageCert: any;
    showContentLogin: boolean = false;
    linkGooglePlay = 'https://play.google.com/store/apps/details?id=com.dais.software.mqes&hl=bg&gl=US'
    // URL param that is used for automated tests for skipping reCaptcha
    QAkey: string | undefined;

    // _token: string;
    // accounts: any;
    // errorMessageCert: any;
    // showContentLogin: boolean = false;
    // linkGooglePlay = 'https://play.google.com/store/apps/details?id=com.dais.software.mqes&hl=bg&gl=US'
    constructor(
        private translateService: TranslateService,
        public info: InfoService,
        private store: Store<any>,
        private localStorageService: LocalStorageService,
        private sessionStorageService: SessionStorageService,
        private businessService: BusinessService,

        private auth: AuthenticationService,
        private formBuilder: FormBuilder,
        private router: Router,
        public bissService: BissService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
        this.usingLang = this.translateService.currentLang;
        this.reCaptcha2SiteKey = environment.reCaptcha.reCaptcha2SiteKey;
        this.invisibleCaptchaSiteKey = environment.reCaptcha.invisibleCaptchaSiteKey;
        this.translateService.onLangChange.subscribe(e => this.usingLang = e.lang);
        const ua = navigator.userAgent;
        this.isIE11 = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;


    }

    ngOnInit() {
        setTimeout(() => {
            this.showContentLogin = true
        }, 400);
        // Handling reCaptcha
        this.QAkey = this.activatedRoute.snapshot.queryParams[environment.reCaptcha.automatedTestParamKey];
        const isPersonalReCaptchaActivated = environment.reCaptcha.personalId;
        this.captchaEnabled = configureReCaptchaWithEnv(isPersonalReCaptchaActivated, this.QAkey);
        this.type = (this.localStorageService.getItem('loginWithQr')) ? OperationTypes.LOGIN_WITH_QR : OperationTypes.LOGIN_WITH_EGN;
        this.accounts = this.sessionStorageService.getItem("accounts");
        // Fix for IE first choice for login to be loginWithEgn
        if (this.isIE11) {
            this.type = OperationTypes.LOGIN_WITH_EGN;
        }
        // end

        this.loginForm = this.formBuilder.group({
            personalId: ['', Validators.required],
            recaptcha: this.captchaEnabled ? ['', Validators.required] : [''],
        });

        this.initLogin(this.type);

        this.info.dismissAll();
        this.store
            .select(selectorAuth)
            .subscribe((auth) => {
                this.isAuthenticated = auth ? auth.isAuthenticated : false;
            });
    }

    initLogin(operationType: OperationTypes): void {

        this.operationType = operationType;

        if (operationType !== OperationTypes.LOGIN_WITH_EGN) {
            if (!this.qrData) {
                // Initiates new QR code and starts pulling for confirmation
                this.auth.getQRCode()
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((res) => {
                        this.loading = false;
                        if (res.data) {
                            this.qrData = res.data.qrCode;
                            this.uniqueToken = res.data.uniqueToken;
                            this.startTimer();
                            this.pullForConfirmation();
                        } else {
                            this.translateService.get('auth.QRLoginUnavailable').subscribe((message: string) => {
                                this.info.error(message);
                            });
                            this.switchLoginTo(OperationTypes.LOGIN_WITH_EGN);
                        }
                    });
            } else {
                // We have QR already. Only starts pulling for confirmation
                this.startTimer();
                this.pullForConfirmation();
            }
        }
    }

    idLoginSubmit(): void {
        this.info.dismissAll();
        this.loading = true;
        this.auth.loginById(this.personalId, this.recaptchaResponse, this.QAkey)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((result: ISpringResponseBody) => {
                this.loading = false;           
                if (result.code === LoginIdResponse.OK.code) {
                    this.uniqueToken = result.data;
                    this.idWait();
                } else if (result.code === LoginIdResponse.FORBIDDEN.code) {
                    this.info.error(result.message);
                } else if (result.code === LoginIdResponse.NO_SUCH_ID.code) {
                    this.info.error(result.message);
                } else {
                    this.loading = false;
                    this.info.error(result.message);
                }
            });
    }

    resetLogin(msg: string = '') {

        clearInterval(this.timer);
        this.unsubscribe$.next();
        this.auth.destroySession().subscribe(r => {
            this.loading = false;
            this.qrData = '';
            this.loginForm.reset();

            // In case there is an error message show it
            if (msg !== '') {
                this.info.error(msg);
            }
            if (this.operationType === OperationTypes.TO_BE_CONFIRMED) {
                this.initLogin(OperationTypes.LOGIN_WITH_EGN);
            } else {
                this.initLogin(this.operationType);
            }
        });
    }

    /**
     * Switches login screen to provided type.
     */
    switchLoginTo(type: OperationTypes) {
        this.setStyle = true
        if (type === OperationTypes.EMERGENCY_LOGIN) {
            this.loading = true;
            clearInterval(this.timer);
            this.unsubscribe$.next();
            this.operationType = OperationTypes.EMERGENCY_LOGIN;
            this.loading = false;
            this.setStyle = false;
        } else {
            this.unsubscribe$.next();
            this.auth.destroySession().subscribe(r => {
                this.loading = false;
                if (type === OperationTypes.LOGIN_WITH_QR) {
                    this.initLogin(OperationTypes.LOGIN_WITH_QR);
                } else {
                    clearInterval(this.timer);
                    this.operationType = OperationTypes.LOGIN_WITH_EGN;
                }
            });
        }
    }

    loginWihtBiss() {
        this.bissService.openBissDialog().subscribe({
            next: (res: any) => {
                if (res && res.code === 'ACTIVE_CERTIFICATES_NOT_FOUND') {
                    this.dialog.closeAll();
                    this.translateService.get('bissLogin.activeCertificatesNotFound').subscribe((message: string) => {
                        this.info.error(message);
                    });
                } else {
                    setTimeout(() => {
                        this.dialog.closeAll();
                    }, 1000);
                }
            },
            error: (error) => {
                console.error('Error in loginWihtBiss:', error);
            },
            complete: () => {
                console.log('Biss login completed');
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();

        if (this.progressBarService) {
            this.progressBarService.setNull();
        }
    }
    private idWait() {
        this.startTimer();
        this.operationType = OperationTypes.TO_BE_CONFIRMED;
        this.pullForConfirmation();
    }

    private pullForConfirmation() {
        this.auth.loginCheck(this.uniqueToken)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                res => {
                    if (res.status === 200) {
                        this.checkBusinessAccounts(res.data);
                        this.auth.updatePacks(res.data.packs);
                        clearInterval(this.timer);
                    } else {
                        this.resetLogin(res.message);
                    }
                }
            );
    }

    private startTimer() {
        this.timeLeft = AppConfig.loginTime;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.timeLeft--;
            if (this.timeLeft < 1) {
                clearInterval(this.timer);
                this.unsubscribe$.next();
                this.auth.destroySession().subscribe(r => {
                    this.initLogin(OperationTypes.LOGIN_WITH_EGN);
                    this.loading = false;
                });
            }
        }, 1000);
    }

    getScreenDescriptionKey(isToolTip: boolean): string {
        let text = 'auth.' + this.operationType + '.description';
        if (isToolTip) {
            text += '.tooltip';
        }
        return text;
    }

    login(): void {
        this.store
            .select(selectorSettings)
            .pipe(first())
            .subscribe(settings => {
                this.store.dispatch(new ActionAuthLogin({ loginWithQR: settings.loginWithQR }));
            });
    }
    handleRecaptchaSuccess(result: string) {
        this.recaptchaResponse = result;
    }

    handleRecaptchaLoad() {
        // Nothing is done during captcha load
    }

    handleRecaptchaExpire() {
        // Nothing is done during captcha expire
    }

    checkBusinessAccounts(data) {
        this.businessService.getCompanies(data.userData.cmrId).subscribe(res => {
            console.log('res', res)
            if (res.data && res.data.length > 0) {
                console.log('data', data)
                this.sessionStorageService.setItem("accounts", res.data);
                this.sessionStorageService.setItem("loginEventData", data);
                this.router.navigateByUrl('/accounts');
            } else {
                this.store.dispatch(new ActionAuthLoginSuccess({ auth: data }));
            }
        })

    }

    getMainColumnClass(): string {
        let hasTwoColumnsLayout = this.operationType !== OperationTypes.EMERGENCY_LOGIN;
        return `${hasTwoColumnsLayout ? 'border-r-response' : '' } ${this.loading || this.setStyle || !hasTwoColumnsLayout ? 'w64' : 'w48p'}`;
    }
}
